export default "__VITE_ASSET___4vq4FMv__"